
import { Component, Vue, Watch } from "vue-property-decorator";
import { i18n } from "@/i18n";
import PButton from "@/common/components/look/PButton/PButton.vue";
import PModal from "@/common/components/look/PModal/PModal.vue";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { BFormTextarea } from "bootstrap-vue";

@Component({
  name: "transaction-deletions-upload-modal",
  i18n,
  components: {
    PIcon,
    PModal,
    BFormTextarea,
    PButton,
  },
})
export class TransactionDeletionsUploadModal extends Vue {
  file: any = "";
  reason = "";
  selectedFields: string[] = ["transactionDate"];
  showModal = false;
  title = this.$i18n.t("delete_transactions_panel.upload_title") || "Añadir nuevo archivo";
  secondary = "secondary";
  isDisabled = true;
  fileInputKey = 0;

  openModal(): void {
    this.showModal = true;
  }
  closeModal(): void {
    this.clear();
  }
  clear(): void {
    this.showModal = false;
    this.isDisabled = true;
    this.reason = "";
    this.file = "";
    this.fileInputKey += 1;
  }
  onFileChange(): void {
    this.isDisabled = !this.file || !this.reason;
  }

  @Watch("file")
  onFileUpdated(): void {
    this.onFileChange();
  }

  @Watch("reason")
  onReasonUpdated(): void {
    this.onFileChange();
  }
  async upload(): Promise<void> {
    const formData = new FormData();
    formData.append("file", this.file);
    formData.append("reason", this.reason);
    await this.$services.transactionDeletion
      .uploadDeletionFile(formData)
      .then(() => {
        Vue.swal({
          icon: "success",
          title: this.$t("machine.solution-register-modal.upload_success") as string,
          showConfirmButton: false,
          timer: 2000,
        });
      })
      .then(() => this.$emit("refresh"))
      .then(() => this.clear())
      .catch(() => {
        Vue.swal({
          icon: "error",
          title: this.$t("error.generic") as string,
          showConfirmButton: false,
          timer: 2500,
        });
      });
  }
  async downloadTemplate(): Promise<void> {
    const file = await this.$services.transactionDeletion.downloadTemplate();
    const aElement = document.createElement("a");
    const url = URL.createObjectURL(file);
    aElement.href = url;
    aElement.download = file.name;
    aElement.click();
    window.URL.revokeObjectURL(url);
  }
}
export default TransactionDeletionsUploadModal;
